/** @jsxImportSource @emotion/react */
import React from "react";
import { css, useTheme } from "@emotion/react";
import { COMPLIANCE_COLOR_CODES } from "../../../../services/config";

type AnalysisSummaryProps = {
  analysis: any;
  large?: boolean;
};

const AnalysisSummary: React.FC<AnalysisSummaryProps> = ({
  analysis,
  large = false,
}) => {
  const responses = analysis?.responses || [];
  const theme = useTheme();

  const scrollToResultItem = (item: string) => {
    if (typeof document !== "undefined") {
        const element = document.getElementById(item);
        if (element) {

            const offset = document?.querySelector(".root-layout > div:first-child")?.getBoundingClientRect()?.height || 0;
            const rect = element.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition: number = rect.top + scrollTop - (offset + 50);
            window.scrollTo({ top: targetPosition, behavior: "smooth" });
            element.click();
        }
    }
  };
  

  const containerStyle = css`
    display: flex;
    gap: 5px;
    justify-content: start;
    align-items: center;
    flex-wrap: wrap;
  `;

  const smallCircleStyle = (backgroundColor: string) => css`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${backgroundColor};
    margin: 1px;
  `;

  const largeCircleStyle = (backgroundColor: string) => css`
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: ${backgroundColor};
    color: #000;
    font-weight: bold;
    font-size: ${theme.typography.body.fontSize};
    margin: 2px;
    cursor: pointer;
  `;
  return (
    <div css={containerStyle}>
      {responses.map((item: any, index: number) => {
        let color: string = "";
        let isValid = Object.keys(item?.response).includes('is_valid') ? item?.response?.is_valid : item?.response?.category;
        isValid = Number(isValid).toString();
        if (isValid === "-1") {
          color = '#607A8C' // Default color if not applicable in COMPLIANCE_COLOR_CODES
        }  else {
          color = COMPLIANCE_COLOR_CODES[isValid  as "-1" | "0" | "1" | "2" | "3"] || "";
        }
        return large ? (
          <div key={index} css={largeCircleStyle(color)} onClick={() => scrollToResultItem(item?.response?.title)}>
            {index + 1}
          </div>
        ) : (
          <div key={index} css={smallCircleStyle(color)} />
        );
      })}
    </div>
  );
};

export default AnalysisSummary;
